const serverConfig = {
  baseURL: "https://huiyi.envtime.com/api",
  imageURL: 'https://huiyi.envtime.com/',
  signUrl: 'https://huiyi.envtime.com/',
  uploadURL: 'https://huiyi.envtime.com/index.php/api/ajax/upload',
  useTokenAuthorization: true, // 是否开启 token 认证
};
export default serverConfig;



// WEBPACK FOOTER //
// ./src/http/config/index.js